module.exports = __webpack_public_path__ + "assets/robot-and-voice-assistant.svg";